// extracted by mini-css-extract-plugin
export default {"tooltip":"yp-z","sharingV2":"zp-z","sharingIconsV2":"Ap-z","links":"Bp-z","link":"Cp-z","facebookV2":"Dp-z","twitterV2":"Ep-z","pinterestV2":"Fp-z"};